import { connect } from 'react-redux';
import { IState } from '../../store';
import { closeFailure } from '../../store/deal-rent';
import { DealRentFailureModal } from './DealRentFailureModal';

export function mapStateToProps(state: IState) {
  return {
    isOpen: state.dealRent.isFailureModal,
  };
}

export const DealRentFailureModalContainer = connect(mapStateToProps, { closeModal: closeFailure })(
  DealRentFailureModal,
);
